import Vue from 'vue'

// Exposes the current Bootstrap breakpoint (kept in sync by App.vue) to every component.
//   isPhone  → xs            (< 576px)
//   isMobile → xs, sm        (< 768px)  – phones
//   isTablet → xs, sm, md    (< 992px)  – phones + iPad portrait
Vue.mixin({
    computed: {
        $bp() {
            return this.$store ? this.$store.getters['app/currentBreakPoint'] : 'xl'
        },
        isPhone() {
            return this.$bp === 'xs'
        },
        isMobile() {
            return this.$bp === 'xs' || this.$bp === 'sm'
        },
        isTablet() {
            return this.$bp === 'xs' || this.$bp === 'sm' || this.$bp === 'md'
        }
    }
})
